<template>
  <v-container :fluid="isFluid">
    <v-row>
      <v-col>
        <div class="d-flex align-center">
          <h2 class="h2">{{ title }}</h2>
          <slot name="action">
            <v-btn text @click="$emit('reload')">
              <v-icon>mdi-reload</v-icon>
            </v-btn>
            <v-btn color="primary" v-if="enableCreate" @click="$emit('create')">
              <v-icon>mdi-plus-thick</v-icon> 添加
            </v-btn>
          </slot>
          <v-spacer />
          <slot name="btn"></slot>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col style="flex: 1">
        <slot name="searchBox" :ctx="this">
          <v-text-field
            solo
            filled
            prepend-inner-icon="mdi-magnify"
            v-model="searchVal"
            :placeholder="searchBoxPlaceholder"
          />
        </slot>
      </v-col>
      <v-col cols="auto" v-if="$scopedSlots.filterRight">
        <slot name="filterRight"></slot>
      </v-col>
    </v-row>
    <v-row v-if="$scopedSlots.filter" class="mb-4">
      <v-col style="flex: 1">
        <slot name="filter"></slot>
      </v-col>
    </v-row>
    <!--    <v-row v-if="$vuetify.breakpoint.mobile">-->
    <!--      <v-col :cols="cols" :key="x._id" v-for="x in data.docs">-->
    <!--        <slot name="card" :cardContent="x"></slot>-->
    <!--      </v-col>-->
    <!--    </v-row>-->
    <v-data-table
      :id="printId"
      :item-key="itemKey"
      :items="data.docs"
      :server-items-length="data.pages || data.totalPages || 1"
      :items-per-page="limit || 10"
      :disable-sort="true"
      hide-default-footer
      :headers="header"
      :calculate-widths="isFluid"
      @click:row="x => $emit('navDetails', x)"
      :itemClass="itemClass"
      :class="{ 'dense-table': dense }"
    >
      <template v-slot:item.time="{ item }">
        {{ item.time | datetimeRange }}
      </template>
      <template v-slot:item.status="{ item }">
        <div :style="{ color: getColor(item.status) }" label>
          {{ item.status | status }}
        </div>
      </template>
      <template v-for="(_, name) in $scopedSlots" v-slot:[name]="props">
        <slot :name="name" v-bind="props" />
      </template>
    </v-data-table>
    <div class="d-flex align-center justify-center">
      <div class="text-caption grey--text">
        共 {{ data.totalDocs || data.total || 0 | toThousandFilter }} 條記錄
      </div>
      <v-pagination
        v-model="pageVal"
        :length="data.pages || data.totalPages || 1"
        :total-visible="10"
      />
    </div>
    <slot></slot>
  </v-container>
</template>

<script>
import { printWithIframe } from '@/services/utils';
import dayjs from 'dayjs';

// Generate unique ID for each component instance
let instanceCounter = 0;

export default {
  name: 'ListView',
  props: {
    title: {},
    search: {},
    page: {},
    limit: { default: 10 },
    data: { default: () => ({}) },
    enableCreate: { default: true },
    populate: {},
    cols: { type: Number, default: 12 },
    header: {
      default: () => [{ text: 'ID', value: '_id' }],
    },
    isFluid: { default: false },
    itemKey: { type: String, default: '_id' },
    searchBoxPlaceholder: { type: String, default: '' },
    itemClass: { type: [String, Function], default: '' },
    dense: { type: Boolean, default: false },
  },
  emits: ['create', 'reload', 'navDetails'],
  data() {
    return {
      printId: `listview-print-${++instanceCounter}`,
    };
  },
  computed: {
    searchVal: {
      get() {
        return this.search;
      },
      set(val) {
        this.$emit('update:search', val);
      },
    },
    pageVal: {
      get() {
        return this.page;
      },
      set(val) {
        this.$emit('update:page', val);
      },
    },
  },
  methods: {
    getColor(status) {
      if (status === '97$cancelled' || status === '98$absent') return 'red';
      // else return 'green'
    },
    handlePrint() {
      printWithIframe(this.printId);
    },
  },
};
</script>
